import { axiosInstance2 } from "../helpers/axios";

const getDashBoard = (sucursal, distribuidor, securitykey) => {
  // El header Authorization se agrega automáticamente mediante el interceptor de axios
  return axiosInstance2
    .post("dashboard/get_user_metrics/", {
      sucursal: sucursal,
      distribuidor: distribuidor,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      /*console.log("error");
        console.log(err.message);
        console.log(err.response.status);*/
      return err.response.status;
    });
};

export default { getDashBoard };
